import gql from 'graphql-tag';
const SAVE_STUDENT_SETTING = gql `
  mutation keyboardingSaveStudentSetting(
    $value: JSON!
    $where: KeyboardingStudentSettingWhereInput!
  ) {
    keyboardingSaveStudentSetting(value: $value, where: $where) {
      id
      setting
      value
    }
  }
`;
export default SAVE_STUDENT_SETTING;
